module.exports = __webpack_public_path__ + "static/media/brandcase1.473534e1.png";